import api from "./client";

import type { ApiResponse, BaseFilterParams, Paginated } from "#/types/api";
import type { Shipment, UpdateShipmentPayload } from "#/types/shipment";

export const shipmentApi = {
  getAll: (
    params?: BaseFilterParams
  ): Promise<ApiResponse<Paginated<Shipment[]>>> =>
    api.get("/shipment", { params }),
  getById: (id: number): Promise<ApiResponse<Shipment>> =>
    api.get(`/shipment/${id}`),
  update: (
    id: number,
    body: UpdateShipmentPayload
  ): Promise<ApiResponse<Shipment>> => api.patch(`/shipment/${id}`, body),
  delete: (id: number): Promise<ApiResponse<void>> =>
    api.delete(`/shipment/${id}`),
};
